import { Stack } from "@mui/material";
import { CustomTextView } from "../../../component/CustomTextView";
import { CustomTextField } from "../../../component/CustomTextField";
import { useTranslation } from "react-i18next";
import char from "../../../../assets/images/characters/daam-c6.png";
import { CustomImageView } from "../../../component/CustomImageView";

export function ChooseTeamsNameView({
  firstTeamName,
  secondTeamName,
  onFirstTeamNameChanged,
  onSecondTeamNameChanged,
  firstTeamNameRef,
  secondTeamNameRef,
}: {
  firstTeamName: string;
  secondTeamName: string;
  onFirstTeamNameChanged: (txt: string) => void;
  onSecondTeamNameChanged: (txt: string) => void;
  firstTeamNameRef: any;
  secondTeamNameRef: any;
}) {
  const { t } = useTranslation();
  return (
    <Stack
      spacing={4}
      width={"100%"}
      alignItems={"center"}
      height={"100%"}
      justifyContent={"space-between"}
      sx={{ overflow: "auto" }}
      p={2}
    >
      <Stack
        alignItems={"center"}
        width={"100%"}
        spacing={2}
        justifyContent={"space-between"}
        direction={"row"}
      >
        <CustomTextView
          text={t("what_to_name_teams")}
          fontWeight="bold"
          variant="h6"
        />
      </Stack>

      <CustomImageView
        src={char}
        width={120}
        height={100}
        scale="contain"
        showLoading={false}
      />
      <Stack alignItems={"center"} width={"100%"} spacing={0}>
        <Stack width={"100%"} spacing={1}>
          <CustomTextView text={t("first_team")} variant="body1" />
          <CustomTextField
            placeholder={t("first_team")}
            onTextChange={onFirstTeamNameChanged}
            value={firstTeamName}
            maxLength={12}
            ref={firstTeamNameRef}
          />
        </Stack>
        <Stack width={"100%"} spacing={1}>
          <CustomTextView text={t("second_team")} variant="body1" />
          <CustomTextField
            placeholder={t("second_team")}
            onTextChange={onSecondTeamNameChanged}
            value={secondTeamName}
            maxLength={12}
            ref={secondTeamNameRef}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
